export default {
  refreshMenuItems: 'refresh.menu.items',
};
